export class InvoiceItemClassification {
    description?: string;

    name?: string;

    pimsGeneratedId?: string;

    pimsId?: string;
}
